import { isAdminRole } from '@utils/stationScope';

const CHOICES = [
  { id: 'both', title: 'BOH and FOH', hint: 'Sees both departments' },
  { id: 'BOH',  title: 'BOH only',    hint: 'Back of house: apron and cargo' },
  { id: 'FOH',  title: 'FOH only',    hint: 'Front of house: check-in, gates, ticket desk' },
];

const labelCls = 'text-2xs font-mono uppercase tracking-widest text-gl-muted';

/** Department access section of the user drawer. `form` is { role, area } with area 'both' | 'BOH' | 'FOH'. */
export function AreaAccess({ form, setForm }) {
  const adminRole = isAdminRole(form.role);
  const area = adminRole ? 'both' : form.area;

  return (
    <fieldset className="space-y-3 border-t border-gl-border pt-4">
      <legend className={`${labelCls} pr-2`}>Department access</legend>

      <div role="radiogroup" aria-label="Department access" className="grid gap-2">
        {CHOICES.map((c) => (
          <label
            key={c.id}
            className={`relative block text-left rounded-xl px-3 py-2.5 transition-colors has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-gl-ghost ${adminRole ? 'opacity-45 cursor-not-allowed' : 'cursor-pointer'}`}
            style={area === c.id
              ? { background: 'rgba(45,125,70,0.14)', border: '1px solid rgba(74,174,73,0.7)' }
              : { background: 'transparent', border: '1px solid #24405F' }}
          >
            <input
              type="radio"
              name="department-access"
              value={c.id}
              checked={area === c.id}
              disabled={adminRole}
              onChange={() => setForm((f) => ({ ...f, area: c.id }))}
              className="absolute inset-0 w-full h-full opacity-0 cursor-[inherit]"
            />
            <span className="block text-sm text-gl-ghost">{c.title}</span>
            <span className="block text-xs text-gl-muted">{c.hint}</span>
          </label>
        ))}
      </div>

      {adminRole && <p className="text-xs text-gl-muted">Admins always see both departments. This cannot be narrowed.</p>}
    </fieldset>
  );
}
